<template>
  <div>
    <AuthOtp :title="widget.translate('pweb_title_verify_identity', 'Verify Identity')" v-if="isPhoneOtp" :lang="lang" :phoneFlag="true" :phoneNumber="phoneNumber" :eventType="'verifyPhoneOtp'" @onResendVerificationCode="resendOtp" @onSubmit="onSubmit" />
    <div v-else class="signIn-box phone-signIn text-center forgot-container">
      <img class="logo mb-30" v-if="studyConfig" :src="studyConfig.studyLogoUrl" />
      <p class="SignIn-title mb-30" v-translate:SIGN_IN_TITLE="lang">
        Please enter the phone number of the device you wish to receive the verification code on.
      </p>
      <div class="phone-number-wrap information-phone-wrap position-relative">
        <vue-tel-input
          class="mb-0 mr-0"
          wrapperClasses="vue-tel-macho-style input-empty"
          :dropdownOptions="{ showDialCodeInSelection: true }"
          mode="national"
          validCharactersOnly
          enabledCountryCode
          type="tel-input"
          defaultCountry="us"
          @country-changed="countryChanged"
          @onInput="phoneValidated"
          @validate="phoneValidated"
          v-model="phoneNumber"
          v-vue-tel-label="widget.translate('verification_phone_number_mobile', 'Verification Phone Number (Mobile)')"
          name="verificationPhone"
          v-validate="'required'"
          :preferredCountries="['us']"
          :class="{
            input: true,
            'is-danger': errors.has('verificationPhone'),
            'is-success': !errors.has('verificationPhone')
          }"
        />
        <span v-if="errors.has('verificationPhone')" class="error-style phone-error-style" v-translate:error_mandatory_field="lang">Phone number is required.</span>
        <span v-else-if="phoneNumber && !validTelNumber" class="error-style phone-error-style" v-translate:label_enter_valid_phone="lang">Please enter a valid phone number.</span>
      </div>
      <div class="form-group mb-0">
        <button :disabled="!validTelNumber" @click="redirectToOtp()" class="btn signIn-btn secondary-bg" v-translate:send_phone_verification_title="lang">
          Send Verification
        </button>
      </div>
    </div>
    <Modal :show="notValidVerificationPhoneNumber" :cancelButton="false" :title="modal.title" :helpText="modal.helpText" :okButton="modal.okBtnTitle" @modalCallback="() => $emit('onChangeSigninMethod', true)" />
    <div class="modal fade" id="beforeLogin" tabindex="-1" role="dialog" aria-labelledby="clear_all_notify" aria-hidden="true">
      <div class="modal-dialog " role="document">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <div class="verification text-center mt-15 pt-17 p-2">
              <label class="email-id">{{ errorMessage }}</label>
            </div>
            <div class="row leave_study_btn_grp">
              <div class="col-6 col-md-6">
                <button data-dismiss="modal" class="btn leavestudy" v-translate:CANCEL_BUTTON_TITLE="lang">
                  Cancel
                </button>
              </div>
              <div class="col-6 col-md-6">
                <button class="btn leave_study_cntue primary-bg" data-toggle="modal" data-target="#YesleaveStudyModal" v-on:click.prevent="permitAlreadyLogin" data-dismiss="modal" v-translate:YES_TEXT="lang">
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Widget } from "@/components/services/participant-service";
import localStorageService from "@/services/localStorage";
import nprogress from "nprogress";
import $ from "jquery";
import AuthOtp from "@/components/participant-portal/auth/otp";
import Modal from "@/components/participant-portal/common/modal";
export default {
  name: "login-with-phone-number",
  components: { AuthOtp, Modal },
  props: ["isOnCancelClick", "isOnBackClick", "studyId", "userCredentials", "isStudySelected"],
  data() {
    return {
      loading: false,
      phoneNumber: "",
      errorMessage: "",
      selectedStudyId: null,
      isLoginSuccess: false,
      isUserAlreadyLoggedIn: false,
      widget: new Widget(),
      studyConfig: null,
      validTelNumber: false,
      isPhoneOtp: false,
      showCancelModal: false,
      notValidVerificationPhoneNumber: false,
      phoneObject: null,
      otp: null,
      modal: {
        title: "",
        helpText: "",
        okBtnTitle: "",
        cancelBtnTitle: false
      }
    };
  },
  mounted() {
    this.selectedStudyId = this.studyId;
  },
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication", "getParticipantsPortalGlobalElements"]),
    isDisabled() {
      return !this.userCredentials.email || !this.userCredentials.password;
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  watch: {
    getParticipantsPortalGlobalElements(val) {
      this.studyConfig = val;
    },
    studyId(val) {
      this.selectedStudyId = val;
    },
    isOnCancelClick() {
      this.showCancelModal = !this.showCancelModal;
    },
    isOnBackClick() {
      this.$router.push({ name: "participants-portal-auth-login" });
    }
  },
  methods: {
    ...mapActions(["awsCognitoLogin", "participantLogin", "participantLogout", "participantLoadProfile"]),
    onSubmit(otp) {
      this.otp = otp;
      this.loginUser();
    },
    async loginUser() {
      if (!this.errors.any()) {
        this.formErrors = false;
        try {
          nprogress.start();
          const postData = Object.assign({}, this.userCredentials);
          postData.language = localStorageService.getItem("pw-languageId");
          postData.country = localStorageService.getItem("pw-countryId");
          postData.studyId = this.selectedStudyId ? this.selectedStudyId : "";
          postData.isUserAlreadyLoggedIn = true;
          delete postData.email;
          delete postData.password;
          postData.mobile = this.phoneObject.number.significant;
          postData.mobileCountryCode = "+" + this.phoneObject.country.dialCode;
          postData.otp = this.otp;
          localStorageService.setItem("pw-deviceId", postData.deviceId);
          await this.participantLogin(postData);
          this.$emit("mobile-input", this.phoneObject);
        } catch (error) {
          nprogress.done();
          let message = "";
          switch (error.message) {
            case "ANOTHER_PARTICIPANT_LOGIN_ACTIVE":
              message = this.widget.translate(error.message, "Another active login has been detected for this account. Would you like to sign out of all other sessions?");
              break;
            case "PASSWORD_ENTERED_IS_INCORRECT":
              message = this.widget.translate(error.message, "Password entered is incorrect");
              break;
            case "UNABLE_TO_VERIFY_EMAIL_PASSWORD":
              message = this.widget.translate(error.message, "Unable to verify email and/or password.");
              break;
            case "UNABLE_TO_LOGIN_PARTICIPANT_WITHDRAWN":
              message = this.widget.translate(error.message, "Your account has been deactivated. If you have any questions, please contact your study team.");
              break;
            case "PARTICIPANT_CONFIGURED_LANGUAGE_ERROR":
              message = this.widget.translate(error.message, "The language does not match your original selection. If you wish to change the language you are using for this study, please contact your study team.");
              break;
            case "USER_CREDENTIALS_NOT_FOUND":
              message = this.widget.translate(error.message, "Unable to verify email and/or password.");
              break;
            case "PARTICIPANT_UNABLE_TO_LOGIN":
              message = this.widget.translate(error.message, "Unable to login, please try after some time.");
              break;
            case "email_verification_reconfirm_message":
              message = this.widget.translate(error.message, "Unable to login, please try after some time.");
              break;
            case "EMAIL_INCORRECT_FOUND":
              message = this.widget.translate("UNABLE_TO_VERIFY_EMAIL_PASSWORD", "Unable to verify email and/or password.");
              break;
            case "label_verification_code_invalid":
              message = this.widget.translate("label_verification_code_invalid", "The verification code you entered is not correct. Please try again.");
              break;
          }
          if (error.message == "ANOTHER_PARTICIPANT_LOGIN_ACTIVE") {
            this.isUserAlreadyLoggedIn = true;
            this.errorMessage = message;
            $("#beforeLogin").modal("toggle");
          } else {
            message ? this.$toastr.error(message) : this.$toastr.error(error.message);
          }
        }
      }
    },
    activeState(state) {
      switch (state) {
        case "username":
          this.$router.push({
            name: "participants-portal-auth-forgot-username"
          });
          break;
        case "password":
          this.$router.push({
            name: "participants-portal-auth-forgot-password"
          });
          break;
      }
    },
    async permitAlreadyLogin() {
      this.userCredentials.isUserAlreadyLoggedIn = true;
      await this.loginUser();
    },
    phoneValidated(phoneObject) {
      if (phoneObject) {
        this.phoneObject = phoneObject;
        this.validTelNumber = phoneObject && phoneObject.valid ? phoneObject.valid : false;
      }
    },
    countryChanged() {
      this.phoneValidated(this.phoneObject);
    },
    redirectToOtp() {
      if (this.phoneObject) {
        this.$api
          .sendMobileOtpFact(this.phoneObject.country.dialCode, this.phoneObject.number.significant, this.selectedStudyId ? this.selectedStudyId : "")
          .then(() => {
            this.isPhoneOtp = true;
            this.setModalDetails();
          })
          .catch(err => {
            const errorMessage = err.body.message;
            let msg = "";
            if (errorMessage == "label_verification_priveleges_error") {
              this.notValidVerificationPhoneNumber = true;
              this.setModalDetails();
            } else if (errorMessage == "label_account_not_registered") {
              msg = this.widget.translate(errorMessage, "This account is not yet registered.");
              this.$toastr.error(msg);
            } else {
              this.$toastr.error(errorMessage);
            }
          });
      }
    },
    setModalDetails() {
      this.modal.title = this.widget.translate("label_verification_priveleges_error", "This phone number does not have verification privileges.");
      this.modal.helpText = this.widget.translate("label_please_try_signing_in_using_a_different_method", "Please try signing in using a different method.");
      this.modal.okBtnTitle = this.widget.translate("label_ok", "OK");
    },
    resendOtp() {
      this.$api.sendMobileOtpFact(this.phoneObject.country.dialCode, this.phoneObject.number.significant, this.selectedStudyId ? this.selectedStudyId : "").then(() => {
        this.$root.$emit("onOtpResent");
        this.$toastr.success(this.widget.translate("label_verification_code_resent", "Verification code has been resent."));
      });
    }
  }
};
</script>

<style scoped>
.signIn-box.phone-signIn {
  padding: 48px 51px 62px 51px;
}
.error-style {
  font-size: 12px;
  color: #ff4848;
}
.signIn-box.phone-signIn {
  padding: 48px 40px 62px 40px;
}
.SignIn-title {
  padding: 0 15px;
}
.phone-error-style {
  position: absolute;
  left: 126px;
}
</style>
